export default __webpack_public_path__ + "static/media/mainmenu_check.f04976d6.jpg";